import StepIndicator from 'components/layout/StepIndicator';
import useEnquirySteps from './useEnquirySteps';

export interface ApplyStepsProps {
  isLoading?: boolean;
}

const ApplySteps: React.FunctionComponent<ApplyStepsProps> = function ({
  isLoading = false,
}) {
  const { steps } = useEnquirySteps(isLoading);
  if (!steps) return undefined;
  return <StepIndicator steps={steps} isLoading={isLoading} />;
};

export default ApplySteps;
